
@for (item of items; track item; let i = $index) {
  <div class="customizer-delivery-item has-padding-horizontal-30px" (click)="setSelected(i)" [ngClass]="{'is-selected': i === selectedIndex}">
    <h3>{{item.Name}}</h3>
    <p class="multi-lines">{{item.FullAddress}}</p>
    <p>{{item.CustomerNo}}</p>
    @for (email of item.Email; track email) {
      <p>{{email}}</p>
    }
  </div>
}